import { FeeImmunityIcon } from '~/@mid_ui/icons/FeeImmunityIcon'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { useSettings } from '~/@mid_settings/settings'
import { useFeeImmunity } from '~/@pages_investing/fee-immunity/useFeeImmunity'

export function FeeImmunityBanner() {
  const { getLandingPageLink } = useSettings()
  const { showFeeImmunityPromo } = useFeeImmunity()

  if (!showFeeImmunityPromo) return null

  return (
    <div className="flex w-full min-h-12 px-5 py-3 bg-purple-light">
      <PageContainer className="flex flex-row justify-between items-center w-full px-0 md:px-3 font-semibold">
        <div className="flex flex-row items-center gap-2 sm:gap-3">
          <FeeImmunityIcon
            className="shrink-0 text-purple"
            width={24}
            height={24}
          />
          <span className="text-black">
            Investujte minimálne 1000 € do 30. 6. 2026 a získajte poplatkovú
            imunitu.
          </span>
        </div>

        <a
          href={getLandingPageLink('poplatkova-imunita')}
          target="_blank"
          rel="noopener noreferrer"
          className="self-center text-purple text-base text-nowrap underline min-w-[120px] text-right">
          Ako to funguje?
        </a>
      </PageContainer>
    </div>
  )
}
